<template>
  <div class="box box_v" style="height: 100%">
    <div class="mini-header-wrapper">
      <div class="left">
        <div class="iconfont icon-fanhui2" @click="goback"></div>
      </div>
      <div class="mini-header">模块设置</div>
      <div class="newvote">
        <Button class="btn-dc" @click="setModule">保存</Button>
      </div>
    </div>
    <div class="item-wrapper box box_f1">
      <Card style="width: 100%;margin-right: 20px;margin-bottom: 20px">
        <div class="card-content box">
          <div class="box_f1">
            <!--标题-->
            <div class="i-title">
              <label class="i-label">标题</label>
              <Input
                class="i-input"
                v-model="title"
                width="360px"
                placeholder="请输入标题"
                :maxlength="32"
              />
            </div>
            <!--服务类型图标 -->
            <div class="i-title1">
              <label class="i-label" style="color:#999">图标</label>
              <div
                class="i-input"
                @mouseover="mouseOver"
                @mouseleave="mouseLeave"
                style="max-width: 85px"
              >
                <img v-if="src" :src="src" alt />
                <div v-else class="no-pic"></div>
                <div class="icon" :style="display" @click="showServiceList">
                  <i class="iconfont icon-bianji1"></i>
                </div>
              </div>
            </div>
            <!--地图图标-->
            <div class="i-title">
              <label class="i-label ">
                地图图标
                <Tooltip
                  content="社区管理->企业->地图及统计功能中本分类的企业在地图上的点位图标"
                  placement="right"
                >
                  <div class="tishi-icon">?</div>
                </Tooltip>
              </label>
              <div class="ditu-icon" @click="showDituList">
                <div v-if="dituIcon" class="dituicon-wrapper">
                  <img :src="dituIcon" />
                </div>
                <div
                  v-else
                  class="no-ditiicon iconfont icon-tianjiajiahaowubiankuang"
                ></div>
              </div>
            </div>
            <!--统计图颜色-->
            <div class="i-title box">
              <label class="i-label ">
                统计图颜色
                <Tooltip
                  content="社区管理->企业->统计功能中本分类的柱状图颜色"
                  placement="right"
                >
                  <div class="tishi-icon">?</div>
                </Tooltip>
              </label>
              <ColorPicker v-model="color" />
            </div>
            <!--子模块-->
            <div class="i-title1 box">
              <label class="i-label ">子模块</label>
              <div>
                <div v-for="(item, index) in childList" class="box child-modal">
                  <Input v-model="item.value" style="width: 360px" />
                  <div
                    class="iconfont icon-quxiao1 close"
                    @click="delChild(index)"
                  ></div>
                  <div
                    v-if="index != 0"
                    class="iconfont icon-shangyi- up"
                    @click="upChild(index)"
                  ></div>
                  <div
                    v-if="index != childList.length - 1"
                    class="iconfont icon-xiayi- down"
                    @click="downChild(index)"
                  ></div>
                </div>
                <div class="add-btn">
                  <div class="iconfont icon-tianjia"></div>
                  <div @click="addChild">子模块</div>
                </div>
              </div>
            </div>
          </div>
          <div class="box_f1 box example">
            <div class="box" style="margin-right: 20px">示例</div>
            <div class="box_f1 eg-img">
              <div class="img">
                <img class="box" :src="src" alt />
              </div>
              <p>{{ title }}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>

    <Modal v-model="showDel" title="选择图标" width="522" @on-ok="ok">
      <div class="box icon-check-wrapper">
        <div
          class="icon-check"
          v-for="(item, index) in iconList"
          :key="index"
          @click="checkIcon(index)"
        >
          <img
            v-if="clickUpload == 'service'"
            class="service-pic"
            :src="item.url"
          />
          <img v-if="clickUpload == 'ditu'" class="ditu-pic" :src="item.url" />
          <div class="gou" v-if="item.isCheck">
            <i class="iconfont icon-duigou"></i>
          </div>
        </div>
        <div
          @click="addIcon"
          style="width: 20%;display: flex;justify-content: center"
        >
          <div class="add-icon">
            <i
              class="iconfont icon-tianjiajiahaowubiankuang"
              style="font-size: 36px"
            ></i>
          </div>
          <input
            type="file"
            id="uploads"
            class="upload-btn"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="uploadImg"
            hidden
          />
        </div>
      </div>
      <Spin fix v-if="iconLoading"></Spin>
    </Modal>
    <Spin fix size="large" v-if="loading"></Spin>
    <upload-img
      :imgArr="imgArr"
      :imgNumber="imgNumber"
      :imgHeight="60"
      :imgWidth="50"
      @saveImg="saveImg"
      :isClick="isClick"
      :isClickE="isClickE"
      :fixedNumber="fixedNum"
    >
    </upload-img>
    <!--删除弹窗-->
    <Modal v-model="showDelModal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <span>删除确认</span>
      </p>
      <div style="text-align:center">
        <p>该子模块已存在,是否确认删除？</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          @click="delChildItem"
          :loading="shanchuIng"
          >删除</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import uploadImg from "../../components/uploadImg";

var that;
export default {
  data() {
    return {
      showDelModal: false, //是否显示删除子模块确认框
      delId: "", //要删除的子模块id
      delIndex: "", //要删除的子模块索引值
      shanchuIng: false, //删除子模块按钮的loading状态
      id: "", //服务类型id
      title: "", //服务类型名字
      display: "display: none",
      iconList: [], //弹窗图标列表，动态赋值
      dropList: [], //水滴图标列表
      serviceList: [], //服务类型图标列表
      src: "", //服务类型图标
      loading: false,
      showDel: false,
      imgNumber: 1,
      imgArr: [],
      iconLoading: false,
      iconCheck: {},
      dituIcon: "", //地图图标
      isClick: 0, // 上传图片的事件触发标志
      isClickE: null, // 上传图片事件的触发对象 event
      clickUpload: "", //点击上传图片的类型  是地图图标还是图标
      fixedNum: [1, 1],
      color: "",
      childList: []
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    mouseOver() {
      this.display = "";
    },
    mouseLeave() {
      this.display = "display: none";
    },
    getDetail() {
      var url = this.urlobj.getTypeDetail(this.id);
      return new Promise((resolve, reject) => {
        this.$get(url)
          .then(res => {
            resolve(res.rows[0]);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getDropIconList() {
      var url = this.urlobj.getTypeIcon;
      return new Promise(resolve => {
        this.$post(url, {
          pageNum: 1, //当前页码--不传查询全部,
          pageSize: 999, //每页大小--不传查询全部
          communityId: "", //社区ID，不传为当前登录社区,
          iconType: "drop" //图标类型：drop--地图水滴图标，service--服务类型图标
        })
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    getServiceIconList() {
      var url = this.urlobj.getTypeIcon;
      return new Promise(resolve => {
        this.$post(url, {
          pageNum: 1, //当前页码--不传查询全部,
          pageSize: 999, //每页大小--不传查询全部
          communityId: "", //社区ID，不传为当前登录社区,
          iconType: "service" //图标类型：drop--地图水滴图标，service--服务类型图标
        })
          .then(res => {
            resolve(res);
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    getModuleDetail() {
      this.loading = true;
      var getDropIconList = this.getDropIconList();
      var getServiceIconList = this.getServiceIconList();
      var promiseList = [getDropIconList, getServiceIconList];
      if (this.id) {
        var getDetail = this.getDetail();
        promiseList.push(getDetail);
      }
      Promise.all(promiseList).then(res => {
        var dropList = res[0].rows.map(item => {
          return {
            iconId: item.id,
            url: item.iconUrl,
            isCheck: this.id ? item.iconUrl == res[0].dropUrl : false
          };
        });
        var serviceList = res[1].rows.map(item => {
          return {
            iconId: item.id,
            url: item.iconUrl,
            isCheck: this.id ? item.iconUrl == res[0].iconUrl : false
          };
        });
        try {
          this.title = res[2].title;
          this.src = res[2].iconUrl;
          this.dituIcon = res[2].dropUrl;
          this.color = res[2].color16;
          this.childList = res[2].children.map(item => {
            return {
              value: item.title,
              id: item.id
            };
          });
        } catch (e) {}
        this.dropList = dropList;
        this.serviceList = serviceList;
        this.loading = false;
      });
    },
    showServiceList() {
      this.iconList = this.serviceList;
      this.clickUpload = "service";
      this.fixedNum = [1, 1];
      this.showDel = true;
    },
    showDituList() {
      this.iconList = this.dropList;
      this.clickUpload = "ditu";
      this.fixedNum = [2, 3];
      this.showDel = true;
    },
    checkIcon(index) {
      for (let i = 0; i < this.iconList.length; i++) {
        this.iconList[i].isCheck = false;
        if (i == index) {
          this.iconList[i].isCheck = true;
          this.iconCheck = this.iconList[i];
        }
      }
    },
    ok() {
      if (this.clickUpload == "service") {
        this.src = this.iconCheck.url;
      } else {
        this.dituIcon = this.iconCheck.url;
      }
    },
    saveImg(data) {
      if (this.clickUpload == "ditu") {
        //上传的是地图图标
        this.saveDitu(data);
      } else {
        // 上传的是服务类型图标
        this.saveTubiao(data);
      }
    },
    // 处理地图图标
    saveDitu(data) {
      var that = this;
      this.iconLoading = true;
      var path = data.path;
      var url = this.urlobj.addCompanyIcon;
      var data = {
        id: "", //主键ID，不传或-1代表新增,
        communityId: "", //社区ID，不传为当前登录社区,
        iconType: "drop", // 图标类型：drop--地图水滴图标，service--服务类型图标,
        iconUrl: path //图标URL,
      };
      this.$post(url, data).then(res => {
        this.getDropIconList().then(res => {
          var iconList = res.rows.map(item => {
            return {
              iconId: item.id,
              url: item.iconUrl,
              isCheck: item.iconUrl == that.dituIcon ? true : false
            };
          });
          this.dropList = iconList;
          this.iconList = iconList;
          this.iconLoading = false;
        });
      });
    },
    // 处理服务类型图标
    saveTubiao(data) {
      this.iconLoading = true;
      var path = data.path;
      var url = this.urlobj.addCompanyIcon;
      var data = {
        id: "", //主键ID，不传或-1代表新增,
        communityId: "", //社区ID，不传为当前登录社区,
        iconType: "service", // 图标类型：drop--地图水滴图标，service--服务类型图标,
        iconUrl: path //图标URL,
      };
      this.$post(url, data).then(res => {
        this.getServiceIconList().then(res => {
          var iconList = res.rows.map(item => {
            return {
              iconId: item.id,
              url: item.iconUrl,
              isCheck: item.iconUrl == this.src ? true : false
            };
          });
          this.serviceList = iconList;
          this.iconList = iconList;
          this.iconLoading = false;
        });
      });
    },
    setModule() {
      var children = [];
      if (!this.title) {
        this.$Message.warning("请输入标题");
        return;
      }
      if (!this.src) {
        this.$Message.warning("请选择图标");
        return;
      }
      for (var i = 0; i < this.childList.length; i++) {
        var item = this.childList[i];
        if (!item.value) {
          this.$Message.warning("请补全子模块");
          return;
        }
        children.push({
          id: item.id,
          title: item.value
        });
      }
      var data = {
        id: this.id, // 主键ID，不传或-1代表新增,
        communityId: "", // 社区ID，不传为当前登录社区,
        companyType: "service", // type--企业类型，service--服务类型,
        title: this.title, //企业服务类型名称（最多32字）,
        color16: this.color, //统计图颜色16进制,
        iconUrl: this.src, //业务图标URL,
        dropUrl: this.dituIcon, // 地图水滴图片URL,
        children: this.childList.map(item => {
          return {
            id: item.id,
            title: item.value
          };
        }) //[{id:子模块ID不传代表新增传代表修改,title:子模块标题}...],
      };
      this.loading = true;
      this.$post(this.urlobj.getQiyeType, data)
        .then(res => {
          this.$Message.success("操作成功");
          this.getModuleDetail();
        })
        .catch(e => {
          this.loading = false;
        });
    },
    addIcon() {
      let oInput = document.getElementById("uploads");
      oInput.click();
    },
    // 选择文件 触发
    uploadImg(selectFileEvent) {
      this.isClick++;
      this.isClickE = selectFileEvent;
    },
    // 点击添加子模块
    addChild() {
      this.childList.push({
        value: "",
        id: ""
      });
    },
    //删除子模块
    delChild(index) {
      if (this.childList[index].id) {
        //存在子模块id  删除调用删除接口
        this.delId = this.childList[index].id;
        this.delIndex = index;
        this.showDelModal = true;
      } else {
        this.childList.splice(index, 1);
      }
    },
    delChildItem() {
      var url = this.urlobj.delCompanyType(this.delId),
        shanchuIng = true;
      this.$delete(url)
        .then(res => {
          this.shanchuIng = false;
          this.showDelModal = false;
          this.childList.splice(this.delIndex, 1);
        })
        .catch(e => {
          this.shanchuIng = false;
        });
    },
    //向上移动字模块
    upChild(index) {
      var list = this.childList,
        item = list[index];
      list[index] = list[index - 1];
      list[index - 1] = item;
      this.childList = JSON.parse(JSON.stringify(list));
    },
    // 向下移动子模块
    downChild(index) {
      var list = this.childList,
        item = list[index];
      list[index] = list[index + 1];
      list[index + 1] = item;
      this.childList = JSON.parse(JSON.stringify(list));
    }
  },
  mounted() {
    this.id = this.$route.query.id || "";
    this.getModuleDetail();
  },
  created() {
    that = this;
  },
  components: {
    uploadImg
  }
};
</script>

<style lang="less" scoped>
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
  .iconfont {
    font-size: 26px;
    color: #999;
  }
}

.mini-header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding: 30px 0;
  justify-content: center;
  position: relative;
}

.mini-header {
  font-size: 25px;
  text-align: center;
}

.item-wrapper {
  padding-left: 20px;
}

.newvote {
  position: absolute;
  right: 20px;
  button {
    width: 60px;
    height: 28px;
    line-height: 13px;
  }
}

.i-label {
  width: 90px;
  margin-right: 20px;
  white-space: nowrap;
  text-align: right;
  font-size: 14px;
  color: #666;
  /deep/ .ivu-tooltip-inner {
    max-width: 460px;
    background-color: #f4f4f4;
    color: #999;
  }
  /deep/ .ivu-tooltip-arrow {
    left: 1px;
    border-width: 6px 6px 6px 0;
    border-right-color: #ebebeb;
  }
  .tishi-icon {
    color: #fff;
    background: #a8a9a9;
    height: 15px;
    width: 15px;
    line-height: 15px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;
  }
}

.i-input {
  flex: 1;
  position: relative;
  img {
    width: 85px;
    height: 85px;
    border-radius: 50%;
  }
  .no-pic {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    background: #efefef;
  }
  .icon {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    .iconfont {
      font-size: 40px;
      line-height: 85px;
      color: #fff;
    }
  }
}

.i-title {
  display: flex;
  align-items: center;
  line-height: 1;
  margin-bottom: 15px;
}

.i-title1 {
  display: flex;
  margin-bottom: 15px;
  //   align-items: center;
}

.eg-img {
  height: 118px;
  max-width: 98px;
  border: 1px solid #dedede;
  border-radius: 2px;
  text-align: left;
  .img {
    margin: auto;
    width: 62px;
    height: 62px;
    margin-top: 18px;
    img {
      width: 62px;
      height: 62px;
      border-radius: 50%;
    }
  }
  p {
    margin-top: 10px;
    text-align: center;
  }
}

/deep/ .ivu-input {
  max-width: 360px;
}

.example {
  margin-left: -30%;
  margin-top: 5px;
}

.icon-check-wrapper {
  flex-wrap: wrap;
  .icon-check {
    width: 20%;
    height: 73px;
    position: relative;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding-bottom: 20px;
    .service-pic {
      width: 73px;
      height: 73px;
      border-radius: 50%;
    }
    .ditu-pic {
      width: 40px;
      height: 60px;
    }
    .gou {
      position: absolute;
      width: 73px;
      height: 73px;
      color: #fff;
      background: rgba(0, 0, 0, 0.3);
      top: 0;
      left: 50%;
      border-radius: 50%;
      text-align: center;
      transform: translateX(-50%);
      .iconfont {
        font-size: 36px;
        line-height: 73px;
        // text-align: center;
      }
    }
  }
}

.add-icon {
  background: #ccc;
  border-radius: 50%;
  width: 73px;
  height: 73px;
  line-height: 80px;
  text-align: center;
}

.ditu-icon {
  .dituicon-wrapper {
    display: flex;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 1px solid #ececec;
    align-items: center;
    justify-content: center;
    img {
      height: 30px;
      width: 20px;
    }
  }
  .no-ditiicon {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 1px solid #ececec;
    text-align: center;
    color: #b0b0b0;
    font-size: 20px;
    line-height: 50px;
  }
}

.child-modal {
  margin-bottom: 10px;
  line-height: 1;
  align-items: center;
  .close {
    color: #d22b2b;
    font-size: 20px;
    margin-left: 25px;
  }
  .up,
  .down {
    color: #c8c8c8;
    font-size: 20px;
    margin-left: 10px;
  }
}

.add-btn {
  width: 85px;
  height: 30px;
  color: #ff7b44;
  border: 1px dashed #ff7b44;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  .iconfont {
    color: #ff7b44;
    font-size: 15px;
    margin-right: 5px;
    margin-top: -3px;
  }
}
</style>
